var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccessNotificationIcon = function SvgSuccessNotificationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1 4.125 8 1 4.818",
    stroke: "#2C5600",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgSuccessNotificationIcon as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='12' height='9' viewBox='0 0 12 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M11 1L4.125 8L1 4.81818' stroke='%232C5600' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E";